export default function CsharpDefineMethods() {
  return (
    <h2>Csharp Define Methods</h2>
  );
}
